import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { motion } from 'framer-motion';
import { Sun, Anchor, RefreshCw } from 'lucide-react';
const features = [{
  icon: Sun,
  title: 'The "Sunset Reframing" Technique',
  description: 'How Nicoyan elders process stress before it becomes biological damage.'
}, {
  icon: Anchor,
  title: 'The Purpose Anchor',
  description: 'How to find your "Reason to Wake Up" that adds up to 7 years to your life.'
}, {
  icon: RefreshCw,
  title: 'The Modern Reset Loop',
  description: 'A 60-second mental tool to use when work gets overwhelming.'
}];
export function Features() {
  return <section className="py-12 md:py-20 bg-olive-50/50 border-y border-olive-100" data-id="element-1">
      <div className="max-w-4xl mx-auto px-6" data-id="element-2">
        <FadeIn data-id="element-3">
          <h2 className="text-2xl md:text-4xl font-serif text-center text-olive-900 mb-8 md:mb-16" data-id="element-4">
            Inside, You'll Discover:
          </h2>
        </FadeIn>

        <div className="grid gap-4 md:gap-12" data-id="element-5">
          {features.map((feature, index) => <FadeIn key={index} delay={index * 0.2} direction="left" data-id="element-6">
              <motion.div whileHover={{
            x: 10
          }} className="flex items-start p-4 md:p-6 bg-white rounded-lg shadow-sm border border-olive-100/50" data-id="element-7">
                <div className="flex-shrink-0 mr-4 md:mr-6" data-id="element-8">
                  <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-olive-100 flex items-center justify-center text-olive-700" data-id="element-9">
                    <feature.icon className="w-5 h-5 md:w-6 md:h-6" data-id="element-10" />
                  </div>
                </div>
                <div data-id="element-11">
                  <h3 className="text-xl font-serif font-bold text-olive-900 mb-2" data-id="element-12">
                    {feature.title}
                  </h3>
                  <p className="text-stone-600 leading-relaxed" data-id="element-13">
                    {feature.description}
                  </p>
                </div>
              </motion.div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}